import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';

export const ChangeWayModalForm = ({ waysOptions }) => {
	return (
		<Grid className="way-change-modal-form">
			<Grid.Row className="way-change-modal-form__row">
				<Grid.Column width={5} className="way-change-modal-form__column">
					Маршрут
				</Grid.Column>
				<Grid.Column width={8} className="way-change-modal-form__column">
					<Field
						name="way_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите маршрут"
						options={waysOptions}
						noResultsMessage="Неизвестный маршрут"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

ChangeWayModalForm.propTypes = {
	waysOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
};
